export default __webpack_public_path__ + "static/lucrezia2-b1732274c96fdc5bb7e2e538508a03c1.jpg";